import React from "react";
import DocumentLibraryUpdates from "./DocumentLibraryUpdates";

const DocumentLibraryUpdatesList = (props) => {
  return (
    <div className="gridMainContainer2 fullscreen-docLibContainer">
      <DocumentLibraryUpdates displayLoginCol={true} isMaxModal={true} />
    </div>
  );
};
export default DocumentLibraryUpdatesList;
